import { giphyIndigo } from '@giphy/js-brand'
import { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { IconButton } from 'ui'
import { UgeEditorContext } from '../../../contexts/editor'
import { categoryFromSearchTerm, categoryTitle, stickerCategories } from '../../../types/sticker-category'
import { Toolbar } from '../../style'
import { Categories, SearchInput } from './style'

type Props = {
    className?: string
    searchTerm?: string
    onSearch: (term: string) => void
}

const StickersEditorNavigation = ({ className, searchTerm, onSearch }: Props) => {
    const { fetchFavorites } = useContext(UgeEditorContext)
    const [search, setSearch] = useState<string>('')
    const currentCategory = useMemo(() => (searchTerm ? categoryFromSearchTerm(searchTerm) : null), [searchTerm])
    const filteredCategories = useMemo(
        () =>
            stickerCategories.filter((category) => {
                if (!!fetchFavorites) {
                    return true
                }

                return category !== 'giphyfavorites'
            }),
        [!!fetchFavorites]
    )

    const onSubmitSearch = useCallback(() => {
        if (search) {
            onSearch(search)
        } else {
            onSearch(filteredCategories[0])
        }
    }, [search])

    const onCategoryChange = useCallback(
        (index: number) => {
            const category = filteredCategories[index]

            if (category !== searchTerm) {
                onSearch(category)
            }
        },
        [searchTerm]
    )

    useEffect(() => {
        if (currentCategory) {
            setSearch('')
        } else if (searchTerm) {
            setSearch(searchTerm)
        }
    }, [searchTerm, currentCategory])

    return (
        <Toolbar className={className}>
            <SearchInput
                autoFocus
                placeholder="Search all the stickers"
                size="medium"
                value={search}
                onChange={setSearch}
                onEnterKeyPress={onSubmitSearch}
            >
                <IconButton gradient="red-pink" icon="search" size="medium" onClick={onSubmitSearch} />
            </SearchInput>
            <Categories
                color={giphyIndigo}
                gradient="indigo-purple"
                index={currentCategory ? filteredCategories.indexOf(currentCategory) : undefined}
                options={filteredCategories.map(categoryTitle)}
                onChange={onCategoryChange}
            />
        </Toolbar>
    )
}

export default StickersEditorNavigation
